import { render } from "./Loading.vue?vue&type=template&id=f95b4456"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=f95b4456&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__